import { browser } from '$app/environment';
import { SvelteDate } from 'svelte/reactivity';
import { deterministicSeed } from './deterministicSeed';

const ONE_YEAR = 365 * 864e5;

export function clientABTestCookie(cookieName: string) {
	function getCookie() {
		if (!browser) return;

		const cookie = document.cookie.split('; ').find(row => row.startsWith(`${cookieName}=`));
		return cookie?.slice(cookieName.length + 1);
	}

	function setCookie(variant: string) {
		if (!browser) return;

		const expires = new SvelteDate(Date.now() + ONE_YEAR).toUTCString();
		document.cookie = `${cookieName}=${variant}; path=/; expires=${expires}`;
	}

	return {
		getCookie,
		setCookie,
	};
}

export function clientGetAbTestIdentifier(cookieName: string, customIdentifier?: string) {
	if (!browser) return;

	const { getCookie, setCookie } = clientABTestCookie(cookieName);
	let identifier = getCookie();

	if (identifier) {
		return identifier;
	}

	identifier = customIdentifier || globalThis.crypto.randomUUID();
	setCookie(identifier);
	return identifier;
}

interface GetVariantProps<T extends readonly string[]> {
	key: string;
	variants: T;
	identifier: string;
}

export function getVariant<T extends readonly string[]>({ key, variants, identifier }: GetVariantProps<T>) {
	const seed = deterministicSeed(identifier + key);
	const index = Math.floor(seed * variants.length);
	return { variant: variants[index] as T[number], index };
}
